export { Modal as ModalSeries } from './ModalSeries';
